<template>
  <div style="max-width:420px;margin:40px auto">
    <a-card title="Вход" :bordered="false">
      <a-form layout="vertical" @submit.prevent="login">
        <a-form-item label="Телефон">
          <a-input v-model:value="phone" placeholder="+7999..." />
        </a-form-item>

        <a-form-item label="Пароль">
          <a-input-password v-model:value="password" />
        </a-form-item>

        <a-space>
          <a-button type="primary" :loading="loading" @click="login">Войти</a-button>
        </a-space>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { message } from 'ant-design-vue'
import { http } from '../api/http'
import { useAuthStore } from '../stores/auth'
import { useRouter } from 'vue-router'

const phone = ref('')
const password = ref('')
const loading = ref(false)
const auth = useAuthStore()
const router = useRouter()

async function login() {
  loading.value = true
  try {
    const r = await http.post('/api/auth/login', {
      phone: phone.value,
      password: password.value,
    })
    auth.setAuth(r.data.token, r.data.user)
    router.push(auth.role === 'KITCHEN' ? '/kitchen/day' : '/customer/day')
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка входа')
  } finally {
    loading.value = false
  }
}
</script>
